import { useTranslation } from 'react-i18next';
import ServiceCard from '@/components/base/ServiceCard';
import { services } from '@/mocks/categories';

export default function FeaturedServices() {
  const { t } = useTranslation();
  const featured = services.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {t('services.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            {t('services.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {featured.map((svc) => (
            <ServiceCard
              key={svc.id}
              name={svc.name}
              description={svc.description}
              price={svc.price}
              originalPrice={svc.originalPrice}
              duration={svc.duration}
              rating={svc.rating}
              reviewCount={svc.reviewCount}
              store={svc.store}
              image={svc.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}